import { render, staticRenderFns } from "./ItemDetailsComponent.vue?vue&type=template&id=3b660d04&scoped=true&"
import script from "./ItemDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ItemDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailsComponent.vue?vue&type=style&index=0&id=3b660d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b660d04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b660d04')) {
      api.createRecord('3b660d04', component.options)
    } else {
      api.reload('3b660d04', component.options)
    }
    module.hot.accept("./ItemDetailsComponent.vue?vue&type=template&id=3b660d04&scoped=true&", function () {
      api.rerender('3b660d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-shopping-list/ItemDetailsComponent.vue"
export default component.exports